<div class="notification relative">
  <button
    type="button"
    class="rounded-md p-1 px-3"
    [ngClass]="dropdownNotification.dropdownOpened ? 'bg-gray-100' : ''"
    (click)="dropdownNotification.toggle($event)">
    <fa-icon class="text-xl text-gray-500" [icon]="faBell"></fa-icon>
  </button>
  <fc-dropdown #dropdownNotification fcStyleClass="fc-dropdown right-0">
    <div class="notification w-80 rounded-md bg-white shadow-xl">
      <div
        class="border-b border-b-primary-main px-3 py-2 font-bold text-primary-darkest">
        Notification
      </div>
      <div
        class="grid max-h-[384px] divide-y divide-primary-main overflow-y-auto">
        <div
          *ngFor="let notif of notification?.notifications"
          [ngClass]="{ 'bg-primary-main': !notif.read_at }"
          [ngSwitch]="notif.data.type"
          (click)="redirect(notif)"
          class="cursor-pointer py-2 px-3 leading-3 hover:bg-black/5">
          <!-- Case Start -->
          <div *ngSwitchCase="2">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Pesanan Anda telah dikirim
            </div>
            <div class="text-sm text-primary-darkest">
              Pesanan Anda #{{ notif.data.order_id }} telah dikirim. <br />Klik
              untuk memeriksa pesanan Anda.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="5">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Pesanan Anda telah dibatalkan
            </div>
            <div class="text-sm text-primary-darkest">
              Pesanan Anda #{{ notif.data.order_id }} telah dibatalkan.
              <br />Klik untuk memeriksa pesanan Anda.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="6">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Pesanan yang anda laporkan sedang dalam proses
            </div>
            <div class="text-sm text-primary-darkest">
              Pesanan yang telah anda laporkan sedang dalam proses #{{
                notif.data.order_id
              }}. <br />Klik untuk memeriksa pesanan Anda.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="7">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Pesanan anda telah selesai
            </div>
            <div class="text-sm text-primary-darkest">
              Pesanan anda #{{ notif.data.order_id }} telah selesai. <br />Klik
              untuk melihat pesanan anda.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="8">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Komentar baru
            </div>
            <div class="text-sm text-primary-darkest">
              Ada komentar baru di diskusi produk. <br />Klik untuk melihat
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="9">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Ada komentar baru di diskusi produk.
            </div>
            <div class="text-sm text-primary-darkest">
              Ada komentar baru di postingan beautybook anda <br />Klik untuk
              melihat
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="10">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Disukai di beautybook post
            </div>
            <div class="text-sm text-primary-darkest">
              Baru saja disukai di beautybook post anda <br />Klik untuk
              melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="14">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Selamat datang di beautybook
            </div>
            <div class="text-sm text-primary-darkest">
              Verifikasi email kamu untuk mendapatkan voucher spesial.
              <br />Periksa email kamu
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="15">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Checkout telah dibuat
            </div>
            <div class="text-sm text-primary-darkest">
              Checkout #{{ notif.data.checkout_id }} telah dibuat.
              <br />Selesaikan pembayaranmu
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="16">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Checkout ditolak
            </div>
            <div class="text-sm text-primary-darkest">
              Checkout #{{ notif.data.checkout_id }} telah ditolak.
              <br />Hubungi layanan customer untuk info lebih lanjut
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="24">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Terimakasih atas pembayaran anda
            </div>
            <div class="text-sm text-primary-darkest">
              Checkout #{{ notif.data.checkout_id }} telah dibayar. <br />Kami
              akan segera lanjutkan pesanan anda
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="18">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Top-up happy pay telah dikonfirmasi
            </div>
            <div class="text-sm text-primary-darkest">
              Top-up happy pay #{{ notif.data.happy_pay_top_up_id }} telah
              dikonfirmasi. <br />Klik untuk melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="19">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Top-up happy pay telah ditolak
            </div>
            <div class="text-sm text-primary-darkest">
              Top-up happy pay #{{ notif.data.happy_pay_top_up_id }} telah
              ditolak. <br />Klik untuk melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="21">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Penarikan happy pay telah dikonfirmasi
            </div>
            <div class="text-sm text-primary-darkest">
              Penarikan happy pay #{{ notif.data.happy_pay_top_up_id }} telah
              dikonfirmasi. <br />Klik untuk melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="22">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Penarikan happy pay telah ditolak
            </div>
            <div class="text-sm text-primary-darkest">
              Penarikan happy pay #{{ notif.data.happy_pay_top_up_id }} telah
              ditolak. <br />Klik untuk melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchCase="23">
            <div class="relative text-sm font-semibold text-primary-darkest">
              Perubahan saldo happy pay
            </div>
            <div class="text-sm text-primary-darkest">
              Kami telah merubah saldo happypay anda <br />Klik untuk melihat.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <div *ngSwitchDefault>
            <div class="relative text-sm font-semibold text-primary-darkest">
              Unhandled Notifications
            </div>
            <div class="text-sm text-primary-darkest">
              Unhandled Notifications.
            </div>
            <span class="text-xs text-slate-500">{{ notif.timeStamp }}</span>
          </div>
          <!-- Case End -->
        </div>
      </div>
      <div
        class="flex items-center justify-between border-t border-t-primary-main p-3">
        <div
          (click)="markAllAsRead()"
          class="cursor-pointer text-sm text-primary-md-dark duration-200 ease-in-out hover:text-primary-darkest">
          <fa-icon [icon]="faCheckDouble"></fa-icon>
          Baca Semua
        </div>
        <button
          class="rounded-md bg-primary-md-dark px-5 py-1 text-sm text-white duration-200 ease-in-out hover:bg-primary-darkest"
          (click)="navigateToAllNotif()">
          View All
        </button>
      </div>
    </div>
  </fc-dropdown>
</div>
